/**
 * A user as the tables show them. `firstName` and `lastName` are nullable on the server
 * (`user.model.ts`), whatever the client-side types claim: a self-signup can leave both empty.
 * PREC-4389: six such users on production, and `row.firstName[0]` in the Users table threw for
 * each, so their company could not open its own Users page.
 */
export interface NamedUser {
	firstName?: string | null;
	lastName?: string | null;
	email?: string | null;
}

/** Two letters for the avatar: the name's initials, else the email's first letter. */
export const userInitials = (user: NamedUser | null | undefined): string => {
	const initials = `${user?.firstName?.[0] ?? ""}${user?.lastName?.[0] ?? ""}`;

	return initials || (user?.email?.[0]?.toUpperCase() ?? "");
};

/** The name to show: first and last name, else the email. */
export const userDisplayName = (user: NamedUser | null | undefined): string =>
	[user?.firstName, user?.lastName].filter(Boolean).join(" ") || user?.email || "";
